var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"loader",class:_vm.className},[_c('span',{ref:"bg",staticClass:"o-loader__bg"}),_c('span',{ref:"wave",staticClass:"o-loader__wave"})])}
var staticRenderFns = []

export { render, staticRenderFns }